module.exports = __webpack_public_path__ + "yin_huang.png?f08ef6d03689484b9b5f31e2ef6e93c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/yin_huang.png
// module id = 73
// module chunks = 0